
import { apiSlice } from '../../app/api/apiSlice'
// Automatically created using reduxslicer by Simo Virokannas, 2023

export const personApi = apiSlice.injectEndpoints ({ 
  endpoints: (builder) => ({
    listPersons: builder.query ({
      query: (params) => `v2/person/${params ? "?" + new URLSearchParams(Object.entries(params)).toString() : ""}`,
      keepUnusedDataFor: 1,
      providesTags: ["Person"]
    }),
    getPerson: builder.query ({
      query: (person_id) => `v2/person/${person_id}/`,
      keepUnusedDataFor: 1,
      providesTags: ["Person"]
    }),
    getPersonPermissions: builder.query ({
      query: (person_id) => `v2/personpermission/?person=${person_id}`,
      keepUnusedDataFor: 1,
      providesTags: ["PersonPermission"]
    }),
    getPersonRecurring_bonus: builder.query ({
      query: (person_id) => `v2/recurringbonus/?person=${person_id}`,
      keepUnusedDataFor: 1,
      providesTags: ["RecurringBonus"]
    }),
    updatePerson: builder.mutation ({
      query: ({person_id, data}) => ({
        url: `v2/person/${person_id}/`,
        method: 'PUT',
        body: data
      }),
      invalidatesTags: ["Person"]
    }),
    deletePerson: builder.mutation ({
      query: (person_id) => ({
        url: `v2/person/${person_id}/`,
        method: 'DELETE'
      }),
      invalidatesTags: ["Person"]
    }),
    createPerson: builder.mutation ({
      query: (data) => ({
        url: `v2/person/`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ["Person"]
    }),
  })
})


export const {
  useListPersonsQuery,
  useLazyListPersonsQuery,
  useGetPersonQuery,
  useLazyGetPersonQuery,
  useGetPersonPermissionsQuery,
  useGetPersonRecurring_bonusQuery,
  useUpdatePersonMutation,
  useDeletePersonMutation,
  useCreatePersonMutation
} = personApi
